/* prettier-ignore */

import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NewCustomRouteService } from '../../new-custom-route.service';
import { IonicModule } from '@ionic/angular';
import { ToolsService } from 'src/app/services/tools.service';
import { AuthService } from 'src/app/services/auth.service';
import { SendUpdateRouteService } from 'src/app/pages/send-update-route/send-update-route.service';
import { Router } from '@angular/router';

@Component({
  selector: 'route-footer',
  imports: [CommonModule, TranslateModule, IonicModule],
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})

export class RouteFooterComponent {
    public translate = inject(TranslateService);
    private routeService = inject(NewCustomRouteService);
    private tools = inject(ToolsService);
    private router = inject(Router);
    public authService = inject(AuthService);
    public isTechEditMode = computed(() => this.tools.isTechEditMode());
    public isTechMode = computed(() => this.tools.isTechMode());
    public showTimeline = computed(() => this.routeService.showTimeline());
    private sendUpdateService = inject(SendUpdateRouteService);
    public isLoadFromApi = computed(() => this.sendUpdateService.userData()?.id);
    public disableTouch = computed(() => this.routeService.disableTouch())

    toggleView(){
        this.routeService.showTimeline.update(prev => !prev)
    }

    setStartEndPoint(){
        this.routeService.openModalStartEnd();
    }

    sendRoute(){
        this.router.navigateByUrl('/send-update-route');
    }

}